/**
 * Enum for Skill Name List used for smart component
 */
export enum SkillNameList {
  LIGHT_NAME = "LightOnOffName",
  LIGHT_DESCRIPTION = "LightOnOffDescription",
  LIGHT_COMMAND = "LightOnOffCommand",
  LIGHT_STATE = "LightOnOffState",

  DIMMER_NAME = "DimmingName",
  DIMMER_DESCRIPTION = "DimmingDescription",
  DIMMER_ON_OFF_COMMAND = "DimmerOnOffCommand",
  DIMMER_ON_OFF_STATE = "DimmerOnOffState",
  DIMMER_BRIGHTNESS_COMMAND = "DimmerCommand",
  DIMMER_BRIGHTNESS_STATE = "DimmerState",
  DIMMER_FAULT_STATE = "FaultState",

  COUNTER_ELECTRIC_NAME = "ElectricityMeterName",
  COUNTER_ELECTRIC_DESCRIPTION = "ElectricityMeterDescription",
  COUNTER_ELECTRIC_ENERGY_ABSORBED = "ElectricEnergyAbsorbed",
  COUNTER_ELECTRIC_ENERGY_PRODUCED = "ElectricEnergyProduced",
  COUNTER_ELECTRIC_POWER_ACTIVE = "ElectricActivePower",
  COUNTER_ELECTRIC_POWER_EXCHANGE = "ElectricPowerExchange",
  COUNTER_ELECTRIC_ACTIVE_ENERGY_IMPORTED_PREVIOUS_DAY_F1 = "ActiveEnergyImportedPreviousDayF1",
  COUNTER_ELECTRIC_ACTIVE_ENERGY_IMPORTED_PREVIOUS_DAY_F2 = "ActiveEnergyImportedPreviousDayF2",
  COUNTER_ELECTRIC_ACTIVE_ENERGY_IMPORTED_PREVIOUS_DAY_F3 = "ActiveEnergyImportedPreviousDayF3",
  COUNTER_ELECTRIC_ACTIVE_ENERGY_IMPORTED_PREVIOUS_DAY_F4 = "ActiveEnergyImportedPreviousDayF4",
  COUNTER_ELECTRIC_ACTIVE_ENERGY_IMPORTED_PREVIOUS_DAY_F5 = "ActiveEnergyImportedPreviousDayF5",
  COUNTER_ELECTRIC_ACTIVE_ENERGY_IMPORTED_PREVIOUS_DAY_F6 = "ActiveEnergyImportedPreviousDayF6",
  COUNTER_ELECTRIC_ACTIVE_POWER_MAX_24H = "ElectricActivePowerMax24h",
  COUNTER_ELECTRIC_ACTIVE_POWER_FED = "ElectricActivePowerFed",
  COUNTER_ELECTRIC_ACTIVE_POWER_FED_MAX_24H = "ElectricActivePowerFedMax24h",

  COUNTER_HOTWATER_NAME = "HotWaterMeterName",
  COUNTER_HOTWATER_DESCRIPTION = "HotWaterMeterDescription",
  COUNTER_HOTWATER_FLOW = "HotWaterFlow",
  COUNTER_HOTWATER_VOLUME = "HotWaterVolume",

  COUNTER_COLDWATER_NAME = "ColdWaterMeterName",
  COUNTER_COLDWATER_DESCRIPTION = "ColdWaterMeterDescription",
  COUNTER_COLDWATER_FLOW = "ColdWaterFlow",
  COUNTER_COLDWATER_VOLUME = "ColdWaterVolume",

  COUNTER_HEATING_NAME = "HeatingMeterName",
  COUNTER_HEATING_DESCRIPTION = "HeatingMeterDescription",
  COUNTER_HEATING_ENERGY_HEAT = "HeatThermalEnergy",
  COUNTER_HEATING_POWER = "HeatPowerActive",
  COUNTER_HEATING_VOLUME = "HeatVolume",

  COUNTER_DISTRIBUTOR_NAME = "DistributorName",
  COUNTER_DISTRIBUTOR_DESCRIPTION = "DistributorDescription",
  COUNTER_DISTRIBUTOR_CONSUMPTION = "DistributorConsumption",

  COUNTER_GAS_NAME = "GasMeterName",
  COUNTER_GAS_DESCRIPTION = "GasMeterDescription",
  COUNTER_GAS_VOLUME = "GasVolume",

  BLIND_NAME = "BlindsName",
  BLIND_DESCRIPTION = "BlindsDescription",
  BLIND_COMMAND_STOP = "BlindStopCommand",
  BLIND_COMMAND_CLOSE = "BlindCloseCommand",
  BLIND_COMMAND_OPEN = "BlindOpenCommand",
  BLIND_STATE_HEIGHT = "BlindHeightState",
  BLIND_COMMAND_HEIGHT = "BlindHeightCommand",
  SLAT_POSITION_COMMAND = "SlatPositionCommand",
  SLAT_POSITION_COMMAND_MIN = "SlatPositionCommandMin",
  SLAT_POSITION_COMMAND_MAX = "SlatPositionCommandMax",
  SLAT_POSIITION_STATE = "SlatPositionState",

  CONTACT_NAME = "SwitchName",
  CONTACT_DESCRIPTION = "SwitchDescription",
  CONTACT_COMMAND = "SwitchCommand",
  CONTACT_STATE = "SwitchState",

  ALARM_NAME = "AlarmName",
  ALARM_DESCRIPTION = "AlarmDescription",
  ALARM_STATE = "AlarmState",
  ALARM_INVERTED = "Inverted",
  ALARM_RESET = "AlarmReset",

  THERMOSTAT_NAME = "ThermostatName",
  THERMOSTAT_DESCRIPTION = "ThermostatDescription",
  THERMOSTAT_ACTUAL = "ActualTemperature",
  THERMOSTAT_HEATING_COOLING_COMMAND = "HeatingCooling",
  THERMOSTAT_HEATING_COOLING_STATE = "HeatingCoolingState",
  THERMOSTAT_VALVE_STATE = "ValveState",
  THERMOSTAT_HVACMODE_COMMAND = "HVACMode",
  THERMOSTAT_HVACMODE_STATE = "HVACModeState",
  THERMOSTAT_COMFORT_SWITCH = "Comfort",
  THERMOSTAT_STANDBY_SWITCH = "Standby",
  THERMOSTAT_ECONOMY_SWITCH = "Economy",
  THERMOSTAT_PROTECTION_SWITCH = "Protection",
  THERMOSTAT_SETPOINT_BASE = "BaseSetpoint",
  THERMOSTAT_SETPOINT_BASE_STATE = "BaseSetpointState",
  THERMOSTAT_SETPOINT_COOLING_COMFORT = "SetpointCoolingComfort",
  THERMOSTAT_SETPOINT_COOLING_STANDBY = "SetpointCoolingStandby",
  THERMOSTAT_SETPOINT_COOLING_ECONOMY = "SetpointCoolingEconomy",
  THERMOSTAT_SETPOINT_COOLING_PROTECTION = "SetpointCoolingProtection",
  THERMOSTAT_SETPOINT_HEATING_COMFORT = "SetpointHeatingComfort",
  THERMOSTAT_SETPOINT_HEATING_STANDBY = "SetpointHeatingStandby",
  THERMOSTAT_SETPOINT_HEATING_ECONOMY = "SetpointHeatingEconomy",
  THERMOSTAT_SETPOINT_HEATING_PROTECTION = "SetpointHeatingProtection",
  THERMOSTAT_WINDOWS_OPEN_STATE = "WindowsOpenState",
  THERMOSTAT_FANCOIL_COMMAND = "FancoilCommand",
  THERMOSTAT_FANCOIL_COMMAND_MIN = "FancoilCommandMin",
  THERMOSTAT_FANCOIL_COMMAND_MAX = "FancoilCommandMax",
  THERMOSTAT_FANCOIL_STATE = "FancoilState",
  THERMOSTAT_FANCOIL_STATE_MIN = "FancoilStateMin",
  THERMOSTAT_FANCOIL_STATE_MAX = "FancoilStateMax",
  THERMOSTAT_FANCOIL_V0 = "FancoilV0",
  THERMOSTAT_FANCOIL_V1 = "FancoilV1",
  THERMOSTAT_FANCOIL_V2 = "FancoilV2",
  THERMOSTAT_FANCOIL_V3 = "FancoilV3",
  THERMOSTAT_FANCOIL_AUTO_MAN_COMMAND = "FancoilAutoMan",
  THERMOSTAT_AUTO_MAN_STATE = "FancoilAutoManState",
  THERMOSTAT_SETPOINT_BASE_MIN = "BaseSetpointMin",
  THERMOSTAT_SETPOINT_BASE_MAX = "BaseSetpointMax",
  THERMOSTAT_SETPOINT_HEATING_COMFORT_MIN = "SetpointHeatingComfortMin",
  THERMOSTAT_SETPOINT_HEATING_COMFORT_MAX = "SetpointHeatingComfortMax",
  THERMOSTAT_SETPOINT_HEATING_STANDBY_MIN = "SetpointHeatingStandbyMin",
  THERMOSTAT_SETPOINT_HEATING_STANDBY_MAX = "SetpointHeatingStandbyMax",
  THERMOSTAT_SETPOINT_HEATING_ECONOMY_MIN = "SetpointHeatingEconomyMin",
  THERMOSTAT_SETPOINT_HEATING_ECONOMY_MAX = "SetpointHeatingEconomyMax",
  THERMOSTAT_SETPOINT_HEATING_PROTECTION_MIN = "SetpointHeatingProtectionMin",
  THERMOSTAT_SETPOINT_HEATING_PROTECTION_MAX = "SetpointHeatingProtectionMax",
  THERMOSTAT_SETPOINT_COOLING_COMFORT_MIN = "SetpointCoolingComfortMin",
  THERMOSTAT_SETPOINT_COOLING_COMFORT_MAX = "SetpointCoolingComfortMax",
  THERMOSTAT_SETPOINT_COOLING_STANDBY_MIN = "SetpointCoolingStandbyMin",
  THERMOSTAT_SETPOINT_COOLING_STANDBY_MAX = "SetpointCoolingStandbyMax",
  THERMOSTAT_SETPOINT_COOLING_ECONOMY_MIN = "SetpointCoolingEconomyMin",
  THERMOSTAT_SETPOINT_COOLING_ECONOMY_MAX = "SetpointCoolingEconomyMax",
  THERMOSTAT_SETPOINT_COOLING_PROTECTION_MIN = "SetpointCoolingProtectionMin",
  THERMOSTAT_SETPOINT_COOLING_PROTECTION_MAX = "SetpointCoolingProtectionMax",
  THERMOSTAT_ACTUAL_SETPOINT_SUMMER = "ActualSetpointActualSummerSetpoint",
  THERMOSTAT_ACTUAL_SETPOINT_WINTER = "ActualWinterSetpoint",
  THERMOSTAT_SHIFT_SETPOINT = "ShiftSetpoint",
  THERMOSTAT_SHIFT_SETPOINT_MIN = "ShiftSetpointMin",
  THERMOSTAT_SHIFT_SETPOINT_MAX = "ShiftSetpointMax",

  SENSOR_NAME = "SensorName",
  SENSOR_DESCRIPTION = "SensorDescription",
  SENSOR_PRESENCE = "SensorPresence",
  SENSOR_AMBIENT_BRIGHTNESS = "SensorAmbientBrightness",
  SENSOR_AMBIENT_BRIGHTNESS_SETPOINT = "SensorAmbientBrightnessSetpoint",
  SENSOR_AMBIENT_BRIGHTNESS_SETPOINT_MIN = "SensorAmbientBrightnessSetpointMin",
  SENSOR_AMBIENT_BRIGHTNESS_SETPOINT_MAX = "SensorAmbientBrightnessSetpointMax",
  SENSOR_STATE_AUTO_MAN = "SensorStateAutoMan",
  SENSOR_COMMAND_AUTO_MAN = "SensorCommandAutoMan",
  SENSOR_DIMMER_ON_OFF_COMMAND = "SensorOnOffCommand",
  SENSOR_DIMMER_ON_OFF_STATE = "SensorOnOffState",
  SENSOR_DIMMER_COMMAND = "SensorCommand",
  SENSOR_DIMMER_STATE = "SensorState",
  SENSOR_FAULT_STATE = "SensorFaultState",
  SENSOR_DIMMER_NAME = "SensorDimmerName",
  SENSOR_CURRENT_COLOR_TEMPERATURE = "SensorCurrentColorTemperature",
  SENSOR_SETPOINT_COLOR_TEMPERATURE = "SensorSetpointColorTemperature",
  SENSOR_SETPOINT_COLOR_TEMPERATURE_MIN = "SensorSetpointColorTemperatureMin",
  SENSOR_SETPOINT_COLOR_TEMPERATURE_MAX = "SensorSetpointColorTemperatureMax",
  SENSOR_STATE_COLOR_TEMPERATURE = "SensorStateColorTemperature",
  SENSOR_COLOR_TEMPERATURE_AUTOMAN = "SensorColorTemperatureAutoMan",

  WEATHER_STATION_NAME = "WeatherStationName",
  WEATHER_STATION_DESCRIPTION = "WeatherStationDescription",
  WEATHER_STATION_SUNSET_TIME = "WeatherStationSunsetTime",
  WEATHER_STATION_SUNRISE_TIME = "WeatherStationSunriseTime",
  WEATHER_STATION_IS_DAY_NIGHT = "WeatherStationIsDayNight",
  WEATHER_STATION_IS_DAY_VALUE = "WeatherStationIsDayValue",
  WEATHER_STATION_WIND_SPEED = "WeatherStationWindSpeed",
  WEATHER_STATION_WIND_ALARM = "WeatherStationWindAlarm",
  WEATHER_STATION_RAIN_ALARM = "WeatherStationRainAlarm",
  WEATHER_STATION_AMBIENT_BRIGHTNESS = "WeatherStationAmbientBrightness",
  WEATHER_STATION_ACTUAL_TEMPERATURE = "WeatherStationActualTemperature",

  LABEL_BUTTON_NAME = "LabelButtonName",
  LABEL_BUTTON_DEFAULT_IMAGE = "LabelButtonDefaultImage",
  LABEL_BUTTON_ORIENTATION = "LabelButtonOrientation",
  LABEL_BUTTON_FORMATTING = "LabelButtonFormatting",
  LABEL_BUTTON_ADDRESS_COMMAND = "LabelButtonAddressCommand",
  LABEL_BUTTON_ADDRESS_STATE = "LabelButtonAddressState",
  LABEL_BUTTON_ICONS_STATE = "LabelButtonIconsState",

  SCENARIO_NAME = "ScenarioName",
  SCENARIO_DESCRIPTION = "ScenarioDescription",
  SCENARIO = "Scenario",

  PAGE_BREAK_NAME = "PageBreakName",
  PAGE_BREAK_DESCRIPTION = "PageBreakDescription",
  PAGE_BREAK_SHOW_DESCRIPTION = "PageBreakShowDescription",
  PAGE_BREAK_ICON = "PageBreakIcon",
  PAGE_BREAK_ID_ENVIRONMENT = "PageBreakIDEnvironment",
  PAGE_BREAK_MODE = "PageBreakMode",
}
